import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { Inject, Injectable, Optional, PLATFORM_ID, TransferState, makeStateKey, signal } from '@angular/core';
import { UrlSerializer, UrlTree, DefaultUrlSerializer } from '@angular/router';
import { USE_SLASH_TOKEN } from 'tockens';

const STATE_KEY_USESLASH = makeStateKey('useSlash');

@Injectable(
    { providedIn: 'root' }
)

export class CustomeUrlSerializer implements UrlSerializer {
    useSlash = signal<string>('');
    constructor(
        @Inject(PLATFORM_ID) protected platformId: any,
        protected state: TransferState,
        @Optional() @Inject(USE_SLASH_TOKEN) private use_slash: string,
    ) {
        if (isPlatformServer(this.platformId)) {
            this.useSlash.set(this.use_slash);
            this.state.set(STATE_KEY_USESLASH, <any>this.use_slash);
        } else {
            this.useSlash.set(this.state.get(STATE_KEY_USESLASH, <any>''));
        }
    }

    parse(url: any): UrlTree {
        const dus = new DefaultUrlSerializer();
        return dus.parse(this.removeParentheses(url));
    }

    private removeParentheses(url: string): string {
        return url.replace(/\(.+\)/g, '');
    }

    serialize(tree: UrlTree): any {
        const dus = new DefaultUrlSerializer();
        let path = dus.serialize(tree);
        let joinSeparator = '';
        let pathArr = [];
        if(path.indexOf('?') >= 0) {
            joinSeparator = '?';
            pathArr = path.split('?');
        } else if (path.indexOf('#') >= 0) {
            joinSeparator = '#';
            pathArr = path.split('#');
        } else {
            pathArr = [path];
        }
        if (isPlatformBrowser(this.platformId) && !this.useSlash()) {
            const partnerid = window.localStorage.getItem('partnerid');
            if (partnerid?.length > 0) {
                this.useSlash.set(window.localStorage.getItem(partnerid + '_use_slash'));
            }
        }
        if (!pathArr[0].endsWith('/') && this.useSlash() === '1') {
            pathArr[0] += '/';
        }
        path = pathArr.join(joinSeparator);
        // path = path.replaceAll('/main/', '');
        // console.log(pathArr);
        // console.log(path);
        return path;
    }
}
